import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';

@Entity()
export class InstitutionLegalDoc extends MongoEntity {
  static override _class = 'InstitutionLegalDoc';
  static override _collectionName = 'institution-legal-docs';

  @Field(type => String)
  institutionID?: string; // undefined for global settings

  @Field(type => String)
  type!: 'terms-of-use' | 'imprint' | 'privacy' | 'accessibility';

  @Field(type => String) html: Maybe<string>;
}
